// tslint:disable:max-line-length

import React from 'react';

export const UtilityNotes = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M2,2v2h3V2h1.5v2h3V2H11v2h3V2h1v14H1V2H2z M13,13H3v1h10V13z M13,10H3v1h10V10z M13,7H3v1h10V7z M4,0v3H3V0H4z M13,0v3h-1 V0H13z M8.5,0v3h-1V0H8.5z" />
    </svg>
  );
};
